/* unplugin-vue-components disabled */import { render } from "./DownloadTaskNum.vue?vue&type=template&id=ef6bb6c2&scoped=true&ts=true"
import script from "./DownloadTaskNum.vue?vue&type=script&lang=ts"
export * from "./DownloadTaskNum.vue?vue&type=script&lang=ts"

import "./DownloadTaskNum.vue?vue&type=style&index=0&id=ef6bb6c2&lang=scss&scoped=true"

import exportComponent from "/var/static/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.3.4_vue@3.3.4_webpack@4.46.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef6bb6c2"]])

export default __exports__